import type { FaireThemeEntity } from "../../entity_types/theme";

export const cozy_layering_essentials: FaireThemeEntity = {
  token: "cozy-layering-essentials",
  type: "theme",
  name: "Cozy Layering Essentials",
  description: "Versatile cardigans and style-shifting accessories designed for effortless, on-the-go fashion that fits your clothing-focused inventory.",
  teaser: "As a clothing-predicted pop-up, you frequently stock apparel like sweatshirts, knit sweaters, and beanies. These layering pieces complement your existing rotation of women's and kids' wear.",
  detail: "This theme is supported by your dwell-time on the Fashion Contrast Print Cardigan and the Ombre Wavy Long Hair Wig from the additional_context payload.",
  bgColor: "#C4D4B0",
  tileBgColor: "#3a4c6b",
  exactProducts: true,
  retailerToken: "r_vywa5ks4ga",
  productTokens: [
    "p_bjcjxg9mrd",
    "p_6bfhf9tfzt",
    "p_cag49qlfzl",
    "p_up34at3585",
    "p_ug44pmerzk",
    "p_mkme2g8n4r",
    "p_hybf9gwsyh",
    "p_nb2s54h26m",
    "p_nfb8dd5m29",
    "p_uu43zc43dr",
    "p_2zkx8yj39m",
    "p_yvsv8g9xtj",
    "p_vzmvedpg94",
    "p_mgzz9ym525",
    "p_7fpvnmhthc",
    "p_7563dygugm",
    "p_nttjt6p6c2",
    "p_865rtkh7t9",
    "p_3yckw39v8d",
    "p_fydxdns3ub",
    "p_e7hnrhmw9w",
    "p_q34z9t6gse",
    "p_z66ga9spg8",
    "p_hdsjwk36u7",
    "p_hanuey275s",
    "p_d2ga3wmz6f",
    "p_8757zy8tev",
    "p_trpp5ad4tc",
    "p_8jgkf4b8w7",
    "p_34dv9m8bpz",
    "p_2ss973wkpa",
    "p_7vdbnrkhnm",
    "p_8fgaztner7",
    "p_yncne6xkdz",
    "p_chx0gqq4eh",
    "p_uvxxe6zxjz",
    "p_j2ru6uz5cy",
    "p_r4u2rj7s3w",
    "p_c4z26gu3ds",
    "p_43cf8c5f3t",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-26T00:00:00Z",
    importedBy: "manual-v3-import",
  },
};
